import { render } from "./WebDesignIcon.vue?vue&type=template&id=7e73b762"
import script from "./WebDesignIcon.vue?vue&type=script&lang=js"
export * from "./WebDesignIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__